import { FC, memo, useMemo } from 'react'
import classNames from 'classnames'
import { EntityType } from '@crew/enums/domain'

import BaseOutlineVideocam from '~icons/ic/outline-videocam'
import ChatOutline from '~icons/material-symbols/chat-outline'
import OutlineInsertDriveFile from '~icons/ic/outline-insert-drive-file'
import EventAvailable from '~icons/material-symbols/event-available'

type CrewEntityIconProps = {
  entityType: EntityType
  className?: string
  width?: number
  height?: number
}

const DEFAULT_ICON_HEIGHT = 24 as const
const DEFAULT_ICON_WIDTH = 24 as const

export const CrewEntityIcon: FC<CrewEntityIconProps> = memo((props) => {
  const width = props.width ?? DEFAULT_ICON_WIDTH
  const height = props.height ?? DEFAULT_ICON_HEIGHT

  // エンティティタイプに応じたアイコンを決定
  const icon = useMemo(() => {
    switch (props.entityType) {
      case EntityType.Task:
        // タスク
        return <EventAvailable width={width} height={height} />

      case EntityType.Event:
        // 会議
        return <BaseOutlineVideocam width={width} height={height} />

      case EntityType.File:
        // ファイル
        return <OutlineInsertDriveFile width={width} height={height} />

      case EntityType.ChatMessage:
        // チャットメッセージ
        return <ChatOutline width={width} height={height} />

      default:
        return null
    }
  }, [props.entityType, width, height])

  if (!icon) return null

  return (
    <span
      className={classNames(
        'inline-flex items-center justify-center',
        props.className
      )}
    >
      {icon}
    </span>
  )
})
